import React, { useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import TrackingContext from './TrackingContext';
import specsReader from './specsReader';

const track =
  (trackingPageName, actualWizardValues, specs, onTrackingEvent) =>
  (piggyEvent) => {
    const piggyEventWithPageName = { trackingPageName, ...piggyEvent };
    const finalTags = specsReader(
      piggyEventWithPageName,
      actualWizardValues,
      specs
    );
    if (finalTags && finalTags.length > 0) {
      onTrackingEvent(finalTags);
    }
  };

const TrackingWrapper = (props) => {
  const { onTrackingEvent, specs } = props;
  const [trackingPageName, setTrackingPageName] = useState('');
  const [wizardValues, setWizardValues] = useState({});

  return (
    <TrackingContext.Provider
      value={{
        trackingPageName,
        setTrackingPageName,
        track: track(trackingPageName, wizardValues, specs, onTrackingEvent),
        isTrackingInUse: true,
        setWizardValues,
      }}
    >
      {props.children}
    </TrackingContext.Provider>
  );
};

const specsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    description: PropTypes.string,
    eventIdentifier: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
    content: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  })
);

TrackingWrapper.propTypes = {
  children: PropTypes.node,
  specs: specsPropTypes,
  onTrackingEvent: PropTypes.func.isRequired,
};

TrackingWrapper.defaultProps = {
  children: null,
  specs: [],
  onTrackingEvent: noop,
};

export default TrackingWrapper;
